import Icon from './components/Icon'
import Factscarousel from './components/FactsCarousel'
import Partnerscarousel from './components/PartnersCarousel'
import Freecoursecarousel from './components/FreeCourseCarousel'
import HiveMindTextFormatter from './components/HiveMindTextFormatter'

new Vue({
    el: '#icons',
    components: {Icon}
})

new Vue({
    el: '#facts_carousel',
    components: {Factscarousel}
})

new Vue({
    el: '#partners_carousel',
    components: {Partnerscarousel}
})

new Vue({
    el: '#free_course_carousel',
    components: {Freecoursecarousel}
})

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="hive_mind_text"]').forEach(function (element) {
        new Vue({
            el: element,
            components: {
                HiveMindTextFormatter
            }
        });
    });
});


